export default defineNuxtRouteMiddleware((_) => {
  const { isStaff } = storeToRefs(useUserStore())
  if (!isStaff.value) {
    return navigateTo({ name: 'login' })
  }
})
